import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Lock } from "lucide-react";
import api from "@/lib/api";

/** Trial countdown / read-only notice. Silent for licensed workspaces. */
export const TrialBanner = () => {
  const navigate = useNavigate();
  const [sub, setSub] = React.useState(null);

  React.useEffect(() => {
    api.get("/subscription").then(({ data }) => setSub(data)).catch(() => {});
  }, []);

  if (!sub || (!sub.trial && !sub.read_only)) return null;

  const expired = sub.read_only;
  return (
    <div
      data-testid="trial-banner"
      className={`flex flex-wrap items-center justify-between gap-3 border-b px-6 py-2 text-sm font-medium ${
        expired ? "border-red-200 bg-red-50 text-red-900" : "border-amber-200 bg-amber-50 text-amber-900"}`}
    >
      <span className="flex items-center gap-2">
        {expired ? <Lock size={14} /> : <Clock size={14} />}
        <span data-testid="trial-banner-text">
          {expired
            ? "Your trial has ended — this workspace is read-only. Nothing has been deleted."
            : `${sub.days_remaining} day${sub.days_remaining === 1 ? "" : "s"} left of your ${sub.plan_name} trial.`}
        </span>
      </span>
      <button
        data-testid="trial-banner-upgrade"
        onClick={() => navigate("/pricing")}
        className={`rounded-sm px-3 py-1.5 text-xs font-semibold text-white transition-colors ${
          expired ? "bg-red-700 hover:bg-red-800" : "bg-amber-700 hover:bg-amber-800"}`}
      >
        {expired ? "Choose a plan" : "See plans"}
      </button>
    </div>
  );
};
